<template>
    <section class="py-5 bg-light" :class="proData.is_show_error">
      <div class="container">
        <div class="row text-center">
          <div class="col-lg">
            <div class="d-inline-block">
              <div class="media align-items-end">
                <h1>404 Page Not Found!</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="page-holder" :class="proData.is_site_enable">
      <!-- HERO SECTION-->
      <!-- <section class=" hero pb-3 bg-cover bg-center d-flex align-items-center"> -->
      <section class="hero pb-3 bg-cover bg-center" :style="{'background-image': 'url('+proData.store_info.cover+')'}">
        <header class="header">
          <div class="container px-0 px-lg-3">
            <!-- Boutique -->
            <nav class="navbar navbar-expand-lg navbar-light py-3 px-lg-0">
              <a class="navbar-brand" href="/"><span class="font-weight-bold text-uppercase text-light">{{proData.store_info.site_name}}</span></a>
              <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item">
                    <!-- Link--><a class="nav-link active" href="/">Home</a>
                  </li>
                  <!-- <li class="nav-item">
                    <a class="nav-link" href="shop.html">Shop</a>
                  </li> -->
                  <!-- <li class="nav-item">
                    <a class="nav-link" href="detail.html">Product detail</a>
                  </li> -->
                  <!-- <li class="nav-item dropdown"><a class="nav-link dropdown-toggle" id="pagesDropdown" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Pages</a>
                    <div class="dropdown-menu mt-3" aria-labelledby="pagesDropdown">
                      <a class="dropdown-item border-0 transition-link" href="index.html">Homepage</a>
                      <a class="dropdown-item border-0 transition-link" href="shop.html">Category</a>
                      <a class="dropdown-item border-0 transition-link" href="detail.html">Product detail</a>
                      <a class="dropdown-item border-0 transition-link" href="cart.html">Shopping cart</a>
                      <a class="dropdown-item border-0 transition-link" href="checkout.html">Checkout</a></div>
                  </li> -->
                  <li class="nav-item">
                    <span class="nav-link text-light" href="cart.html">Shopping cart</span>
                  </li>
                  <li class="nav-item">
                    <span class="nav-link text-light" href="checkout.html">Checkout</span>
                  </li>
                </ul>
                <!-- <ul class="navbar-nav ml-auto">               
                  <li class="nav-item"><a class="nav-link" href="cart.html"> <i class="fas fa-dolly-flatbed mr-1 text-gray"></i>Cart<small class="text-gray">(2)</small></a></li>
                  <li class="nav-item"><a class="nav-link" href="#"> <i class="far fa-heart mr-1"></i><small class="text-gray"> (0)</small></a></li>
                  <li class="nav-item"><a class="nav-link" href="#"> <i class="fas fa-user-alt mr-1 text-gray"></i>Login</a></li>
                </ul> -->
              </div>
            </nav>
          </div>
        </header>
        <div class="container py-5">
          <div class="row px-4 px-lg-5">
            
            <div class="col-lg-6" style="margin-top: 280px;">
              
              <!-- <p class="text-muted small text-uppercase mb-2" style="color: aliceblue;">New Inspiration 2020</p> -->
              <p class="small text-uppercase mb-2" style="color: aliceblue;">{{proData.store_info.banner_info.title}}</p>
              <h1 class="h2 text-uppercase mb-3" style="color: aliceblue;">{{proData.store_info.banner_info.description}}</h1>
              <!-- <a class="btn btn-dark" href="shop.html">Browse collections</a> -->
            </div>
          </div>
        </div>
      </section>

      <!-- CONTAINER PARTH -->
      <div class="container">
        <!-- Messenger Chat Plugin Code -->
        <div id="fb-root"></div>


        <!-- img/hero-banner-alt.jpg  -->
        <!-- <img style="display: none;" src="https://scontent.fpnh8-1.fna.fbcdn.net/v/t1.0-9/160865526_164509025500366_7552908704811782804_o.jpg?_nc_cat=102&ccb=1-3&_nc_sid=8bfeb9&_nc_eui2=AeEBjh71EZu3Zro4K07haWyXiU8yGDgu1SWJTzIYOC7VJc6bwlyMkgOfY8s9FBZ98u6QLBjNHt3hFakuxIKxdTjZ&_nc_ohc=7mqvBr0iBVAAX_0_9W5&_nc_ht=scontent.fpnh8-1.fna&oh=5fea70e1553a1f1db4c885de2ecbb15b&oe=607AD9F0" alt="cover" /> -->
        
        <!-- CATEGORIES SECTION-->
        <section class="pt-5">
          <header class="text-center">
            <p class="small text-muted small text-uppercase mb-1">{{proData.store_info.video_header.title}}</p>
            <h2 class="h5 text-uppercase mb-4">{{proData.store_info.video_header.description}}</h2>
          </header>
          <!-- <div class="row" style="display: none;">
            <div class="col-4 mb-4 mb-md-0">
              <a class="category-item" href="shop.html">
                <img class="img-fluid" src="img/cat-img-1.jpg" alt="">
                <strong class="category-item-title">Clothes</strong>
              </a>
            </div>
            <div class="col-4 mb-4 mb-md-0">
              <a class="category-item mb-4" href="shop.html">
                <img class="img-fluid" src="img/cat-img-2.jpg" alt="">
                <strong class="category-item-title">Shoes</strong>
              </a>
              <a class="category-item" href="shop.html">
                <img class="img-fluid" src="img/cat-img-3.jpg" alt="">
                <strong class="category-item-title">Watches</strong>
              </a>
            </div>
            <div class="col-4">
              <a class="category-item" href="shop.html">
                <img class="img-fluid" src="img/cat-img-4.jpg" alt="">
                <strong class="category-item-title">Electronics</strong>
              </a>
            </div>
          </div> -->

          <div class="row">
            <div class="col-xl-4 mb-4 col-lg-4 col-12 category-item">
              <!-- embed-responsive embed-responsive-16by9, embed-responsive embed-responsive-21by9, embed-responsive embed-responsive-1by1 -->
              <div class="embed-responsive embed-responsive-4by3">
                <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/d24KVT4SGqM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                <iframe width="560" height="315" v-bind:src="proData.store_info.video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <!-- <iframe class="embed-responsive-item" v-bind:src="proData.store_info.video" width="560" height="462" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe> -->
                <!-- <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/fypO-lbSNno" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                <!-- <strong class="category-item-title">បទពិសោធន៌អ្នកប្រើប្រាស់ផ្ទាល់</strong> -->
              </div>
            </div>
            <!-- <div class="col-xl-4  mb-4 col-lg-4 col-12" style="display: none;">
              <div class="embed-responsive embed-responsive-4by3">
                <iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fweb.facebook.com%2FnearySamrosThomacheat%2Fvideos%2F479902036475934%2F&show_text=false&width=267" width="267" height="476" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
                <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/R2GaX8dAgJc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
            <div class="col-xl-4 mb-4 col-lg-4 col-12" style="display: none;">
              <div class="embed-responsive embed-responsive-4by3">
                <iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fweb.facebook.com%2FnearySamrosThomacheat%2Fvideos%2F1218103621937520%2F&show_text=false&width=267" width="267" height="476" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
                <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/w8PGPhhNAWQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div> -->
          </div>

        </section>
        
        <!-- TRENDING PRODUCTS-->
        <section class="py-5">
          <header>
            <p class="small text-muted small text-uppercase mb-1">{{proData.store_info.product_header.title}}</p>
            <h2 class="h5 text-uppercase mb-4">{{proData.store_info.product_header.description}}</h2>
          </header>
          <div class="row" id="pro">
            <!--  Modal -->
            <div class="modal fade" id="productView" tabindex="-1" role="dialog" aria-hidden="true">
              <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body p-0">
                    <div class="row align-items-stretch">
                      <div class="col-lg-6 p-lg-0">
                        
                        <a class="product-view d-block h-100 bg-cover bg-center" :style="{'background-image': 'url('+proData.item_detail.image+')'}" :href="proData.item_detail.image" data-lightbox="productview" title="Red digital smartwatch"></a>
                        <a class="d-none" :href="proData.item_detail.image" title="Red digital smartwatch" data-lightbox="productview"></a>
                        <a class="d-none" :href="proData.item_detail.image" title="Red digital smartwatch" data-lightbox="productview"></a>
                      </div>
                      <div class="col-lg-6">
                        <button class="close p-4" type="button" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <div class="p-5 my-md-4">
                          <ul class="list-inline mb-2">
                            <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                            <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                            <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                            <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                            <li class="list-inline-item m-0"><i class="fas fa-star small text-warning"></i></li>
                          </ul>
                          <h2 class="h4">{{proData.item_detail.title}}</h2>
                          <p class="text-muted"><del class="small text-muted">${{proData.item_detail.price}}</del> <b>${{proData.item_detail.discount_price}}</b></p>
                          <p class="text-small mb-4" style="white-space:pre-wrap;">{{proData.item_detail.description}}</p>
                          <div class="row align-items-stretch mb-4" style="display:none">
                            <div class="col-sm-7 pr-sm-0">
                              <div class="border d-flex align-items-center justify-content-between py-1 px-3"><span class="small text-uppercase text-gray mr-4 no-select">Quantity</span>
                                <div class="quantity">
                                  <button class="dec-btn p-0"><i class="fas fa-caret-left"></i></button>
                                  <input class="form-control border-0 shadow-0 p-0" type="text" value="1">
                                  <button class="inc-btn p-0"><i class="fas fa-caret-right"></i></button>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-5 pl-sm-0">
                              <!-- href="cart.html" -->
                              <!-- <span class="btn btn-dark btn-sm btn-block h-100 d-flex align-items-center justify-content-center px-0">Add to cart</span> -->
                            </div>
                          </div>
                          <!-- <a class="btn btn-link text-dark p-0" href="#">
                            <i class="far fa-heart mr-2"></i>Add to wish list
                          </a> -->
                          <!-- <div class="fb-messengermessageus" messenger_app_id="312964843506855" page_id="101727785111824" color="blue" size="xlarge">
                          </div> -->
                          <div>
                            <a style="padding-left: 0%;" id="msnnr_btn_anc" href="https://t.me/dmax_store" target="_blank">
                              <div id="messenger_button">
                                <div class="messenger_column btn_icon">
                                    <img src="img/msg_icon.svg" id="msngr_btn_icon">
                                </div>
                                <div class="messenger_column btn_label">
                                  <span>Message Us</span>
                                </div>
                              </div>
                            </a>
                            <br/>
                            <br/>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- PRODUCT-->
            <div class="col-xl-3 col-lg-4 col-6"  v-for="data in proData.datas_list" :key="data.id">
              <div class="product text-center">
                <div class="position-relative mb-3">
                  <div class="badge text-white badge-danger">{{data.status}}</div>
                  <a class="d-block" :href="'/detail?proId='+data.id+'&price='+data.price+'&cat='+data.cat">
                    <img class="img-fluid w-100 my_crop_img" v-bind:src="data.image" :alt="data.title">
                  </a>
                  <div class="product-overlay">
                    <ul class="mb-0 list-inline">
                      <!-- <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-outline-dark" href="#"><i class="far fa-heart"></i></a></li> -->
                      <!-- <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-dark" href="cart.html">Add to cart</a></li> -->
                      <li class="list-inline-item m-0 p-0">
                        <a class="btn btn-sm btn-dark" href="https://t.me/dmax_store" target="_blank">Chat us now</a>
                      </li>
                      <li class="list-inline-item mr-0">
                        <a class="btn btn-sm btn-outline-dark" href="#productView" data-toggle="modal" @click="preview(data)"> 
                          <i class="fas fa-expand"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- href="detail.html" -->
                <h6> <a class="reset-anchor">{{data.title}}</a></h6>
                <!-- <small><del class="small text-muted">${{data.origin_price}}</del></small> -->
                <p class="text-muted"><del class="small text-muted">${{data.price}}</del> ${{data.discount_price}}</p>
                <!-- <div class="fb-messengermessageus mb-3" messenger_app_id="312964843506855" page_id="101727785111824" color="blue" size="xlarge">
                </div> -->
                <!-- <div style="background-color: #eeeeee;">
                  <a href="https://m.me/101727785111824?fbclid=IwAR2OQ3lB4Gz83gVNld8xISKUmZctmRK6bBo3-_t3fgxCCMyCIN3keh_5KSw" target="_blank">
                    <img style=" width: 10%; height: 10%;" src="http://store-images.s-microsoft.com/image/apps.7488.13510798886918977.69182166-f125-495d-80d2-44fdaab21523.8fcea13e-5d9a-48a9-9937-b26deeced1b5">
                    Message Us
                  </a>
                </div> -->
                <div>
                  <a id="msnnr_btn_anc" href="https://t.me/dmax_store" target="_blank">
                    <div id="messenger_button">
                      <div class="messenger_column btn_icon">
                          <img src="img/msg_icon.svg" id="msngr_btn_icon">
                      </div>
                      <div class="messenger_column btn_label">
                        <span>Message Us</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="mb-3"><br/><br/><br/></div>
              </div>
            </div>
            <!-- PRODUCT-->
            <!-- <div class="col-xl-3 col-lg-4 col-6" style="display: none;">
              <div class="product text-center">
                <div class="position-relative mb-3">
                  <div class="badge text-white badge-primary">Sale</div><a class="d-block" href="detail.html"><img class="img-fluid w-100" src="img/product-2.jpg" alt="..."></a>
                  <div class="product-overlay">
                    <ul class="mb-0 list-inline">
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-outline-dark" href="#"><i class="far fa-heart"></i></a></li>
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-dark" href="cart.html">Add to cart</a></li>
                      <li class="list-inline-item mr-0"><a class="btn btn-sm btn-outline-dark" href="#productView" data-toggle="modal"><i class="fas fa-expand"></i></a></li>
                    </ul>
                  </div>
                </div>
                <h6> <a class="reset-anchor" href="detail.html">Air Jordan 12 gym red</a></h6>
                <p class="small text-muted">$300</p>
              </div>
            </div> -->
            <!-- PRODUCT-->
            <!-- <div class="col-xl-3 col-lg-4 col-6">
              <div class="product text-center" style="display: none;">
                <div class="position-relative mb-3">
                  <div class="badge text-white badge-"></div><a class="d-block" href="detail.html"><img class="img-fluid w-100" src="img/product-3.jpg" alt="..."></a>
                  <div class="product-overlay">
                    <ul class="mb-0 list-inline">
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-outline-dark" href="#"><i class="far fa-heart"></i></a></li>
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-dark" href="cart.html">Add to cart</a></li>
                      <li class="list-inline-item mr-0"><a class="btn btn-sm btn-outline-dark" href="#productView" data-toggle="modal"><i class="fas fa-expand"></i></a></li>
                    </ul>
                  </div>
                </div>
                <h6> <a class="reset-anchor" href="detail.html">Cyan cotton t-shirt</a></h6>
                <p class="small text-muted">$25</p>
              </div>
            </div> -->
            <!-- PRODUCT-->
            <!-- <div class="col-xl-3 col-lg-4 col-6" style="display: none;">
              <div class="product text-center">
                <div class="position-relative mb-3">
                  <div class="badge text-white badge-info">New</div><a class="d-block" href="detail.html"><img class="img-fluid w-100" src="img/product-4.jpg" alt="..."></a>
                  <div class="product-overlay">
                    <ul class="mb-0 list-inline">
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-outline-dark" href="#"><i class="far fa-heart"></i></a></li>
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-dark" href="cart.html">Add to cart</a></li>
                      <li class="list-inline-item mr-0"><a class="btn btn-sm btn-outline-dark" href="#productView" data-toggle="modal"><i class="fas fa-expand"></i></a></li>
                    </ul>
                  </div>
                </div>
                <h6> <a class="reset-anchor" href="detail.html">Timex Unisex Originals</a></h6>
                <p class="small text-muted">$351</p>
              </div>
            </div> -->
            <!-- PRODUCT-->
            <!-- <div class="col-xl-3 col-lg-4 col-6" style="display: none;">
              <div class="product text-center">
                <div class="position-relative mb-3">
                  <div class="badge text-white badge-danger">BEST SELLER</div><a class="d-block" href="detail.html"><img class="img-fluid w-100" src="img/product-5.jpg" alt="..."></a>
                  <div class="product-overlay">
                    <ul class="mb-0 list-inline">
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-outline-dark" href="#"><i class="far fa-heart"></i></a></li>
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-dark" href="cart.html">Add to cart</a></li>
                      <li class="list-inline-item mr-0"><a class="btn btn-sm btn-outline-dark" href="#productView" data-toggle="modal"><i class="fas fa-expand"></i></a></li>
                    </ul>
                  </div>
                </div>
                <h6> <a class="reset-anchor" href="detail.html">Red digital smartwatch</a></h6>
                <small><del class="small text-muted">$250</del></small>
                <span class="small text-muted">$250</span>
              </div>
            </div> -->
            <!-- PRODUCT-->
            <!-- <div class="col-xl-3 col-lg-4 col-6" style="display: none;">
              <div class="product text-center">
                <div class="position-relative mb-3">
                  <div class="badge text-white badge-"></div><a class="d-block" href="detail.html"><img class="img-fluid w-100" src="img/product-6.jpg" alt="..."></a>
                  <div class="product-overlay">
                    <ul class="mb-0 list-inline">
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-outline-dark" href="#"><i class="far fa-heart"></i></a></li>
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-dark" href="cart.html">Add to cart</a></li>
                      <li class="list-inline-item mr-0"><a class="btn btn-sm btn-outline-dark" href="#productView" data-toggle="modal"><i class="fas fa-expand"></i></a></li>
                    </ul>
                  </div>
                </div>
                <h6> <a class="reset-anchor" href="detail.html">Nike air max 95</a></h6>
                <p class="small text-muted">$300</p>
              </div>
            </div> -->
            <!-- PRODUCT-->
            <!-- <div class="col-xl-3 col-lg-4 col-6" style="display: none;">
              <div class="product text-center">
                <div class="position-relative mb-3">
                  <div class="badge text-white badge-"></div><a class="d-block" href="detail.html"><img class="img-fluid w-100" src="img/product-7.jpg" alt="..."></a>
                  <div class="product-overlay">
                    <ul class="mb-0 list-inline">
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-outline-dark" href="#"><i class="far fa-heart"></i></a></li>
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-dark" href="cart.html">Add to cart</a></li>
                      <li class="list-inline-item mr-0"><a class="btn btn-sm btn-outline-dark" href="#productView" data-toggle="modal"><i class="fas fa-expand"></i></a></li>
                    </ul>
                  </div>
                </div>
                <h6> <a class="reset-anchor" href="detail.html">Joemalone Women prefume</a></h6>
                <p class="small text-muted">$25</p>
              </div>
            </div> -->
            <!-- PRODUCT-->
            <!-- <div class="col-xl-3 col-lg-4 col-6" style="display: none;">
              <div class="product text-center">
                <div class="position-relative mb-3">
                  <div class="badge text-white badge-"></div><a class="d-block" href="detail.html"><img class="img-fluid w-100" src="img/product-8.jpg" alt="..."></a>
                  <div class="product-overlay">
                    <ul class="mb-0 list-inline">
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-outline-dark" href="#"><i class="far fa-heart"></i></a></li>
                      <li class="list-inline-item m-0 p-0"><a class="btn btn-sm btn-dark" href="cart.html">Add to cart</a></li>
                      <li class="list-inline-item mr-0"><a class="btn btn-sm btn-outline-dark" href="#productView" data-toggle="modal"><i class="fas fa-expand"></i></a></li>
                    </ul>
                  </div>
                </div>
                <h6> <a class="reset-anchor" href="detail.html">Apple Watch</a></h6>
                <p class="small text-muted">$351</p>
              </div>
            </div> -->
          </div>
        </section>

        <!-- ADRESS -->
        <section class="py-5">
          <header>
            <p class="small text-muted small text-uppercase mb-1">Our Location</p>
            <h2 class="h5 text-uppercase mb-4">ទីតាំងហាង DMAX</h2>
          </header>

          <p class="text-small mb-0 text-muted">{{proData.store_info.address}}</p>
          <br/>
          <!-- <section class="hero pb-3 bg-cover bg-center d-flex align-items-center" style="background: url(https://firebasestorage.googleapis.com/v0/b/one-store-c3e30.appspot.com/o/Other%2FScreen%20Shot%202021-10-28%20at%203.33.12%20PM.png?alt=media&token=ab8e09ee-0de1-4f65-bc2e-15faf10a2858)">
            
          </section> -->

          <section class="hero pb-3 d-flex align-items-center">
            <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d977.3097767701156!2d104.9222499284342!3d11.534697999288545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTHCsDMyJzA0LjkiTiAxMDTCsDU1JzIyLjQiRQ!5e0!3m2!1sen!2skh!4v1689591154711!5m2!1sen!2skh" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </section>
        </section>

        <!-- SERVICES-->
        
        <section class="py-5 bg-light">
          <div class="container">
            <div class="row text-center">
              <div class="col-lg-4 mb-3 mb-lg-0">
                <div class="d-inline-block">
                  <div class="media align-items-end">
                    <svg class="svg-icon svg-icon-big svg-icon-light">
                      <use xlink:href="#delivery-time-1"> </use>
                    </svg>
                    <div class="media-body text-left ml-3">
                      <h6 class="text-uppercase mb-1">Free shipping</h6>
                      <p class="text-small mb-0 text-muted">Free shipping in PhnomPenh</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 mb-3 mb-lg-0">
                <div class="d-inline-block">
                  <div class="media align-items-end">
                    <svg class="svg-icon svg-icon-big svg-icon-light">
                      <use xlink:href="#helpline-24h-1"> </use>
                    </svg>
                    <div class="media-body text-left ml-3">
                      <h6 class="text-uppercase mb-1">24 x 7 service</h6>
                      <p class="text-small mb-0 text-muted">24h customer service</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="d-inline-block">
                  <div class="media align-items-end">
                    <svg class="svg-icon svg-icon-big svg-icon-light">
                      <use xlink:href="#label-tag-1"> </use>
                    </svg>
                    <div class="media-body text-left ml-3">
                      <h6 class="text-uppercase mb-1">Festival offer</h6>
                      <p class="text-small mb-0 text-muted">A lot promotion every festival</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- NEWSLETTER-->
        <section class="py-5" style="display:none;">
          <div class="container p-0">
            <div class="row">
              <div class="col-lg-6 mb-3 mb-lg-0">
                <h5 class="text-uppercase">Let's get promotion!</h5>
                <p class="text-small text-muted mb-0">Subcribe for our promotion.</p>
              </div>
              <div class="col-lg-6">
                <form action="#">
                  <div class="input-group flex-column flex-sm-row mb-3">
                    
                    <div class="input-group-append">
                      <input class="form-control form-control-lg py-3" type="email" placeholder="Enter phnone number" aria-describedby="button-addon2">
                      <button class="btn btn-dark btn-block" id="button-addon2" type="submit">Subscribe</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
      

      <div id="tmpScript"></div>
      
    </div>
</template>

<script>
import {onUnmounted, reactive} from 'vue'
import { db } from '../firebase'

    const storeId = "-MmiV5flqvsD_5XndmoW25Dmax";
    export default {
        name: 'Home',
        props: {
            msg: String
        },
        /* data(){
          return {
            is_site_enable: ""
          }
        }, */
        methods: {
          /* sendMessage(item) {
            fbq('track', 'ViewContent', {
              content_ids: item.id,
              value: item.price,
              content_name: item.name,
              currency: "USD"
            })
            console.log("track", item.name)
          }, */
        },
        setup() {
          const proData = reactive({
            datas_list: [],
            item_detail: { },
            store_info: { },
            is_hide: { },
            is_site_enable: "",
            is_show_error: ""
          });

          // Disable 404 page
          proData.is_show_error = "isShowError";

          const getData = db.ref("stores/"+ storeId);
          getData.once("value", function(snapshot) {
            
            var tmpSnap = snapshot.child("product");
            tmpSnap.forEach((doc) => {
                //console.log(doc);
                var tmp = doc.val();
                tmp.id = doc.key;
                tmp.cat = "ecomerce";
                proData.datas_list.push(tmp);
            });

            // Store info datav
            //const fbEmbLink = "https://www.facebook.com/plugins/video.php?height=462&href=https%3A%2F%2Fweb.facebook.com%2FnearySamrosThomacheat%2Fvideos%2F";
            const fbEmbLink = "https://www.youtube.com/embed/";
            //const fbEmbLinkHeight = "%2F&show_text=false&width=560";
            var tmpStoreInfo = {
              site_name: snapshot.child("site_title").val(),
              cover: snapshot.child("cover").val(),
              address: snapshot.child("address").val(),
              banner_info: snapshot.child("banner_info").val(),
              video_header: snapshot.child("video_header").val(),
              product_header: snapshot.child("product_header").val(),
              video: fbEmbLink + snapshot.child("video_id").val()
            };
            proData.store_info= tmpStoreInfo;

            if (snapshot.child("enable").val() == false) {
              //proData.is_hide = { hid: "none" }
              //this.$router.push("/about");
              proData.is_site_enable = "isEnable"
              proData.is_show_error = ""
            }
            


            //proData.datas_list = snapshot.val().map(doc => ({ id: doc.key, ...doc.val() }));
            //console.log(proData.datas_list);
          });

          const preview = (item) => {
            proData.item_detail = item;   
            
            /* //FB.AppEvents.logEvent("previewClicked"),
            Vue.analytics.fbq('track', 'ViewContent', {
              content_ids: item.id,
              value: item.price,
              content_name: item.name,
              content_type: item.cat,
              currency: "USD"
            }) */
          };

          onUnmounted(getData);

          return {
            proData,
            getData,
            preview
          };
        },
        mounted() {
          // Show og:image content image
          let aa = document.createElement('meta');
          aa.setAttribute('property', 'og:image');
          aa.setAttribute('content', this.proData.store_info.cover);
          document.head.appendChild(aa);
          //this.$router.push("/about");
        }
    }
</script>

<style scoped>
    .isEnable {
      display: none;
    }
    .isShowError {
      display: none;
    }
</style>